//  Copyright (c) 2025 coze-dev
//  SPDX-License-Identifier: MIT

export * from '@coze-editor/preset-universal';
export { default } from '@coze-editor/preset-universal';
